import * as React from 'react';
import { useSelector } from 'react-redux';
import { Counter } from '../../components/Counter';
import { selectCounterText, selectIsCompilation } from '../../selectors/pagination';

export const CounterContainer: React.FC = () => {
  const isCompilation = useSelector(selectIsCompilation);
  const counterText = useSelector(selectCounterText);

  if (!counterText || isCompilation) {
    return null;
  }

  return <Counter text={counterText} />;
};
